import { ReactNode, useCallback, useMemo, useRef } from 'react';
import { EntityFooterContext } from './EntityFooterContext';
import { EntityFooterConfig } from './types';

export function EntityFooterProvider({ children }: { children: ReactNode }) {
  const configRef = useRef<EntityFooterConfig | null>(null);
  const subscribersRef = useRef<Set<() => void>>(new Set());

  const subscribe = useCallback((callback: () => void) => {
    subscribersRef.current.add(callback);
    return () => {
      subscribersRef.current.delete(callback);
    };
  }, []);

  const notify = useCallback(() => {
    subscribersRef.current.forEach(cb => cb());
  }, []);

  const value = useMemo(() => ({ configRef, subscribe, notify }), [subscribe, notify]);

  return <EntityFooterContext.Provider value={value}>{children}</EntityFooterContext.Provider>;
}
